import { useQuery } from "react-query";
import { bookConditionsApi, type BookCondition } from "@/lib/api/book-conditions";

export const BOOK_CONDITIONS_QUERY_KEY = ["book-conditions"] as const;

export function useBookConditions(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<BookCondition[]>(
    [...BOOK_CONDITIONS_QUERY_KEY, includeInactive],
    () => bookConditionsApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
